import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import {
    getAccountClientDepartmentByAccountPartyIdAndAccountClientDepartmentIdAsync, deleteAccountClientDepartmentAsync,
    checkedState, unCheckedState, checkedAllState, unCheckedAllState, updateSorting
} from "./ClientDepartmentSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import clsx from "clsx";
import { ClientDepartmentForm } from "./ClientDepartmentForm";
import { getValueFromResource } from "../../../common/timeLiveFunction";
export const ClientDepartmentItem = (props: any) => {
    const { clientDepartmentList, AccountPartyId, t, IsEdit, IsDelete, onhandleOnClickEvent } = props;
    // const [hoveredColumn, setHoveredColumn] = useState(null);
    const { sortOrder, sortColumn, pageSize } = useAppSelector((state) => state.clientDepartment);
    const dispatch = useAppDispatch();

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    }

    const onEditClick = (AccountPartyDepartmentId: number) => {
        dispatch(getAccountClientDepartmentByAccountPartyIdAndAccountClientDepartmentIdAsync(AccountPartyDepartmentId))
            .unwrap()
            .then((originalPromiseResult) => {
                onhandleOnClickEvent({ name: getValueFromResource('Update Client Department', dispatch, t), width: '700px', componentName: <ClientDepartmentForm AccountPartyId={AccountPartyId} t={t} ></ClientDepartmentForm> }, "ClientDepartment", true);
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }

    const onDeleteClick = (AccountPartyDepartmentId: string) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountClientDepartmentAsync(AccountPartyDepartmentId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Client Department delete Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });
    }

    // const handleMouseEnter = (columnIndex: any) => {
    //     setHoveredColumn(columnIndex);
    // }

    // const handleMouseLeave = () => {
    //     setHoveredColumn(null);
    // }

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1,
        }));
    }

    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                        {IsDelete &&
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={clientDepartmentList.every((item: any) => item.isSelected === 0) ? false :
                                            (clientDepartmentList.every((item: any) => item.isSelected === 1 ? true : false))
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                        }
                        <th style={{width:'20%'}}
                            // onMouseEnter={() => handleMouseEnter(0)}
                            // onMouseLeave={handleMouseLeave}
                            >
                                {/* {t('Department Code')} */}
                                {getValueFromResource('Department Code',dispatch, t)}
                            {sortColumn === 'PartyDepartmentCode' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "PartyDepartmentCode") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "PartyDepartmentCode") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                : 
                                // hoveredColumn === 0 && 
                                <><span className='cursor' onClick={() => { onHandleClientSideSorting("asc", "PartyDepartmentCode") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className='cursor' onClick={() => { onHandleClientSideSorting("desc", "PartyDepartmentCode") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{width:'40%'}}
                            // onMouseEnter={() => handleMouseEnter(1)}
                            // onMouseLeave={handleMouseLeave}
                            >
                                {/* {t('Department Name')} */}
                                {getValueFromResource('Department Name',dispatch, t)}
                            {sortColumn === 'PartyDepartmentName' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "PartyDepartmentName") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "PartyDepartmentName") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                : 
                                // hoveredColumn === 1 && 
                                <><span className='cursor' onClick={() => { onHandleClientSideSorting("asc", "PartyDepartmentName") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className='cursor' onClick={() => { onHandleClientSideSorting("desc", "PartyDepartmentName") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{width:'40%'}}
                            // onMouseEnter={() => handleMouseEnter(2)}
                            // onMouseLeave={handleMouseLeave}
                            >
                                {/* {t('Department Location')} */}
                                {getValueFromResource('Department Location',dispatch, t)}
                            {sortColumn === 'PartyDepartmentLocation' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "PartyDepartmentLocation") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "PartyDepartmentLocation") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                : 
                                // hoveredColumn === 2 && 
                                <><span className='cursor' onClick={() => { onHandleClientSideSorting("asc", "PartyDepartmentLocation") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className='cursor' onClick={() => { onHandleClientSideSorting("desc", "PartyDepartmentLocation") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th className='w-10 text-center'></th>
                    </tr>
                </thead>
                <tbody>

                    {clientDepartmentList.length > 0 && clientDepartmentList.map((clientDepartmentDetail: any, i: any) => (
                        <tr key={i}>
                            {IsDelete &&
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check"
                                            checked={clientDepartmentDetail.isSelected == 0 ? false : true}
                                            onChange={(e) => { handleCheckboxChange(e, clientDepartmentDetail.AccountPartyDepartmentId) }}
                                        />
                                    </div>
                                </td>
                            }
                            <td
                                id="kt_OffCanvas"
                                className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                onClick={IsEdit ? () => onEditClick(clientDepartmentDetail.AccountPartyDepartmentId) : undefined}>
                                <span className="d-block">
                                    {clientDepartmentDetail.PartyDepartmentCode}
                                </span>
                            </td>
                            <td><span className="d-block">{clientDepartmentDetail.PartyDepartmentName}</span></td>
                            <td><span className="d-block">{clientDepartmentDetail.PartyDepartmentLocation}</span></td>
                            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                        {IsEdit &&
                                            <>
                                                <div className='menu-hover-bg-sec'>
                                                    <Dropdown.Item
                                                        id="kt_OffCanvas"
                                                        className="menu-item me-lg-0 "
                                                        onClick={() => { onEditClick(clientDepartmentDetail.AccountPartyDepartmentId) }}
                                                    >
                                                        <span className="menu-icon custom-menu">
                                                            <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title custom-menu-fontsize">
                                                            {/* {`${t('Edit')}`} */}
                                                            {getValueFromResource('Edit',dispatch, t)}
                                                            </span>
                                                    </Dropdown.Item>
                                                </div>
                                            </>
                                        }
                                        {IsDelete && IsEdit &&
                                            <div className='separator mb-1 mt-1 opacity-75 '></div>
                                        }
                                        {IsDelete &&
                                            <>
                                                <div className='menu-hover-bg-danger'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0 "
                                                        onClick={() => { onDeleteClick(clientDepartmentDetail.AccountPartyDepartmentId) }}
                                                    >
                                                        <span className="menu-icon  custom-menu">
                                                            <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                            {/* {`${t('Delete')}`} */}
                                                            {getValueFromResource('Delete',dispatch, t)}
                                                            </span>
                                                    </Dropdown.Item>
                                                </div>
                                            </>
                                        }
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                    ))}

                </tbody>
            </table >
            {clientDepartmentList.length === 0 &&
                <div className=''>
                    <p className='noDataFound'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found',dispatch, t)}
                        </p>
                </div>
            }
        </>
    )
}
